import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { Certificate } from '@app/_models/certificate';

@Component({
  selector: 'app-certificate-details',
  templateUrl: './certificate-details.component.html',
  styleUrls: ['./certificate-details.component.less']
})
export class CertificateDetailsComponent implements OnInit, OnChanges {
  @Input() certificate: Certificate;
  @Input() isCertificateExpired: boolean;
  @Input() loading = false;
  @Output() addNewRsaService = new EventEmitter<void>();
  @Output() copyContactNumber = new EventEmitter<string>();
  
  // For animation purposes
  isLoaded = false;

  constructor() { }

  ngOnInit() {
    // Trigger animation after component initializes
    setTimeout(() => {
      this.isLoaded = true;
    }, 100);
  }
  
  ngOnChanges(changes: SimpleChanges) {
    // Reset and retrigger animation when certificate changes
    if (changes.certificate && !changes.certificate.firstChange) {
      this.isLoaded = false;
      setTimeout(() => {
        this.isLoaded = true;
      }, 100);
    }
  }

  onAddNewRsaService() {
    this.addNewRsaService.emit();
  }

  onCopyContact(contact: string) {
    this.copyContactNumber.emit(contact);
  }
}
